module.exports = __webpack_public_path__ + "assets/section-arrow.35325c93.svg";